import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import * as uuid from 'uuid';

@Component({
  selector: 'app-checkbox',
  styleUrls: ['./checkbox.component.scss'],
  templateUrl: './checkbox.component.html'
})
export class CheckboxComponent {
  @Input() name: string;
  @Input() label: string;
  @Input() model: any;
  @Input() value: any;
  @Output() clicked: EventEmitter<any> = new EventEmitter;
  id = 'c' + uuid.v4();


  select(event:any) {
    this.clicked.emit(event)
  }
}
